import { IRealization, IRealizationKlass } from "../state";

const CATEGORY_ALREADY_EXISTS_MESSAGE = "活かし先はすでに存在します";
export const CATEGORY_NAME_MAX_LENGTH = 200;
export const CATEGORY_NAME_TOO_LONG_MESSAGE = `活かし先は${CATEGORY_NAME_MAX_LENGTH}文字以内で入力してください`;

export const CONTENT_MAX_LENGTH = 500;
export const COMMENT_TOO_LONG_MESSAGE = `コメントは${CONTENT_MAX_LENGTH}文字以内で入力してください`;
export const FEEDBACK_TOO_LONG_MESSAGE = `フィードバックは${CONTENT_MAX_LENGTH}文字以内で入力してください`;

export const categoryErrorMessage = (error: {
  field: string;
  message: string;
}): string => {
  if (error.field !== "validation failed") return error.message;

  if (error.message.includes("has already been taken")) {
    return CATEGORY_ALREADY_EXISTS_MESSAGE;
  }

  if (error.message.includes("is too long")) {
    return CATEGORY_NAME_TOO_LONG_MESSAGE;
  }

  return error.message;
};

const contentTooLongErrorMessage = (
  error: { field: string; message: string },
  tooLongMessage: string,
): string => {
  if (
    error.field === "validation failed" &&
    error.message.includes("is too long")
  ) {
    return tooLongMessage;
  }
  return error.message;
};

export const commentErrorMessage = (error: {
  field: string;
  message: string;
}): string => contentTooLongErrorMessage(error, COMMENT_TOO_LONG_MESSAGE);

export const feedbackErrorMessage = (error: {
  field: string;
  message: string;
}): string => contentTooLongErrorMessage(error, FEEDBACK_TOO_LONG_MESSAGE);

export function update_realizations_state(
  realizations: IRealization[],
  realizationId: number,
): IRealization[] {
  return realizations.map(realization => ({
    ...realization,
    comment_count:
      realization.id === realizationId
        ? (realization.comment_count || 0) + 1
        : realization.comment_count,
    has_comment:
      realization.id === realizationId ? true : realization.has_comment,
    has_my_comment:
      realization.has_my_comment || realization.id === realizationId,
  }));
}

export function update_realization_klasses_state(
  realization_klasses: IRealizationKlass[],
  realizationId: number,
): IRealizationKlass[] {
  return realization_klasses.map(realization_klass => ({
    ...realization_klass,
    comment_count:
      realization_klass.realization.id === realizationId
        ? realization_klass.comment_count + 1
        : realization_klass.comment_count,
    has_comment:
      realization_klass.realization.id === realizationId
        ? true
        : realization_klass.has_comment,
    realization: {
      ...realization_klass.realization,
      has_my_comment:
        realization_klass.realization.has_my_comment ||
        realization_klass.realization.id === realizationId,
    },
  }));
}
